<div class="container">
    <mat-card-title class="mat-card-title">Location</mat-card-title>
    <hr class="horizontal-line">
        <div fxLayout="row" class="card-container" >
            <div fxFlex="25" class="location-div">
                <div class="location-icon" fxLayout="Column"> 
                    <i class="material-icons">location_on</i>
                    <h1 class="location-label">{{ locationData?.label }}</h1>
                        <hr class="horizontal-line">
                    </div>  
                    <div class="location-detail-container">
                        <div class="location-details">
                            <div class="data-label">Location ID</div>
                            <span id="location-id" class="ng-binding location-data">{{ locationData?.id }}</span>
                        </div>
                                    
                        <div class="location-details">
                            <div class="data-label">User Name</div>
                            <span id="location-user-name" class="ng-binding location-data">{{capitalizeFirstLetter(locationData?.user_name) }}</span>
                        </div>

                        <button class="mat-button-iaqcharts" mat-raised-button (click)="openIAQChartsPopup()">IAQ Charts</button>
                    </div>                        
                </div>
    
        <div fxFlex="75" fxLayout="column">
            <div class="event-member-panel">
                <mat-card-header class="header" >
                    <mat-card-title class="mat-card-info" (click)="memberInfoToggle=!memberInfoToggle"><a href="javascript:">Members</a></mat-card-title>
                </mat-card-header>
                    <app-members-panel *ngIf="memberInfoToggle"></app-members-panel>
            </div>
            <div class="event-member-panel">
                <mat-card-header class="header" >
                    <mat-card-title class="mat-card-info" (click)="eventInfoToggle=!eventInfoToggle"><a href="javascript:">Events</a></mat-card-title>
                </mat-card-header>
                <app-location-component *ngIf="eventInfoToggle"></app-location-component>
            </div>
        </div>
        
    </div>
</div>
   
 